import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext(null);
const STORAGE_KEY = "theme-dark-mode";

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved !== null) return saved === "true";
    } catch {
      // localStorage unavailable (e.g. private mode) - continue with the default
    }
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  });

  // Tailwind's darkMode:'class' reads this class on the <html> element.
  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(darkMode));
    } catch {
      // ignore if localStorage is unavailable
    }
  }, [darkMode]);

  const value = useMemo(
    () => ({
      darkMode,
      toggleTheme: () => setDarkMode((prev) => !prev),
    }),
    [darkMode]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme mora da se koristi unutar <ThemeProvider>");
  }
  return ctx;
};
